import { render, staticRenderFns } from "./DocuDetail.vue?vue&type=template&id=456a7579&scoped=true&"
import script from "./DocuDetail.vue?vue&type=script&lang=js&"
export * from "./DocuDetail.vue?vue&type=script&lang=js&"
import style0 from "./DocuDetail.vue?vue&type=style&index=0&id=456a7579&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a7579",
  null
  
)

export default component.exports